require('./products-new-container.scss')

module.exports = {
  template: require('./products-new-container.pug')()
  controller: require('./products-new-container.ctrl')
}
